import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DStyles />
<DVirtualHeight />

<DiscourseRoot {{did-insert this.trackDiscoursePainted}}>
  <a href="#main-container" id="skip-link">{{i18n "skip_to_main_content"}}</a>
  <DDocument />
  <PageLoadingSlider />
  <PluginOutlet
    @name="above-site-header"
    @connectorTagName="div"
    @outletArgs={{hash currentPath=this.router._router.currentPath}}
  />

  {{#if this.showSiteHeader}}
    {{#if this.header.useGlimmerHeader}}
      <GlimmerSiteHeader
        @canSignUp={{this.canSignUp}}
        @showCreateAccount={{route-action "showCreateAccount"}}
        @showLogin={{route-action "showLogin"}}
        @showKeyboard={{route-action "showKeyboardShortcutsHelp"}}
        @toggleMobileView={{route-action "toggleMobileView"}}
        @logout={{route-action "logout"}}
        @sidebarEnabled={{this.sidebarEnabled}}
        @showSidebar={{this.showSidebar}}
        @toggleSidebar={{this.toggleSidebar}}
      />
    {{else}}
      <SiteHeader
        @canSignUp={{this.canSignUp}}
        @showCreateAccount={{route-action "showCreateAccount"}}
        @showLogin={{route-action "showLogin"}}
        @showKeyboard={{route-action "showKeyboardShortcutsHelp"}}
        @toggleMobileView={{route-action "toggleMobileView"}}
        @logout={{route-action "logout"}}
        @sidebarEnabled={{this.sidebarEnabled}}
        @navigationMenuQueryParamOverride={{this.navigationMenuQueryParamOverride}}
        @showSidebar={{this.showSidebar}}
        @toggleSidebar={{action "toggleSidebar"}}
      />
    {{/if}}
  {{/if}}

  <SoftwareUpdatePrompt />

  {{#if this.siteSettings.enable_offline_indicator}}
    <OfflineIndicator />
  {{/if}}

  <PluginOutlet
    @name="below-site-header"
    @connectorTagName="div"
    @outletArgs={{hash currentPath=this.router._router.currentPath}}
  />

  <div id="main-outlet-wrapper" class="wrap" role="main">
    <div class="sidebar-wrapper">
      {{! empty div allows for animation }}
      {{#if (and this.sidebarEnabled this.showSidebar)}}
        <Sidebar @toggleSidebar={{action "toggleSidebar"}} />
      {{/if}}
    </div>

    <LoadingSliderFallbackSpinner />

    <PluginOutlet @name="before-main-outlet" />

    <div id="main-outlet">
      <PluginOutlet @name="above-main-container" @connectorTagName="div" />
      <div class="container" id="main-container">
        {{#if this.showTop}}
          <CustomHtml @name="top" />
        {{/if}}
        <NotificationConsentBanner />
        <PwaInstallBanner />
        <GlobalNotice />
        <PluginOutlet
          @name="top-notices"
          @connectorTagName="div"
          @outletArgs={{hash currentPath=this.router._router.currentPath}}
        />
      </div>

      {{outlet}}

      <CardContainer />
      <PluginOutlet
        @name="main-outlet-bottom"
        @outletArgs={{hash showFooter=this.showFooter}}
      />
    </div>

    <PluginOutlet @name="after-main-outlet" />

    {{#if this.showPoweredBy}}
      <PoweredByDiscourse />
    {{/if}}
  </div>

  <PluginOutlet
    @name="above-footer"
    @connectorTagName="div"
    @outletArgs={{hash showFooter=this.showFooter}}
  />
  {{#if this.showFooter}}
    <CustomHtml
      @name="footer"
      @triggerAppEvent="true"
      @classNames="custom-footer-content"
    />
  {{/if}}
  <PluginOutlet
    @name="below-footer"
    @connectorTagName="div"
    @outletArgs={{hash showFooter=this.showFooter}}
  />

  <DLightbox />
  <ModalContainer />
  <DialogHolder />
  <TopicEntrance />
  <ComposerContainer />
  <RenderGlimmerContainer />

  {{#if this.showFooterNav}}
    <FooterNav />
  {{/if}}
</DiscourseRoot>

<DMenus />
<DTooltips />
<DToasts />
*/
{
  "id": "ZBSHgsFC",
  "block": "[[[8,[39,0],null,null,null],[1,\"\\n\"],[8,[39,1],null,null,null],[1,\"\\n\\n\"],[8,[39,2],[[4,[38,3],[[30,0,[\"trackDiscoursePainted\"]]],null]],null,[[\"default\"],[[[[1,\"\\n  \"],[10,3],[14,6,\"#main-container\"],[14,1,\"skip-link\"],[12],[1,[28,[35,4],[\"skip_to_main_content\"],null]],[13],[1,\"\\n  \"],[8,[39,5],null,null,null],[1,\"\\n  \"],[8,[39,6],null,null,null],[1,\"\\n  \"],[8,[39,7],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-site-header\",\"div\",[28,[37,8],null,[[\"currentPath\"],[[30,0,[\"router\",\"_router\",\"currentPath\"]]]]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showSiteHeader\"]],[[[41,[30,0,[\"header\",\"useGlimmerHeader\"]],[[[1,\"      \"],[8,[39,10],null,[[\"@canSignUp\",\"@showCreateAccount\",\"@showLogin\",\"@showKeyboard\",\"@toggleMobileView\",\"@logout\",\"@sidebarEnabled\",\"@showSidebar\",\"@toggleSidebar\"],[[30,0,[\"canSignUp\"]],[28,[37,11],[\"showCreateAccount\"],null],[28,[37,11],[\"showLogin\"],null],[28,[37,11],[\"showKeyboardShortcutsHelp\"],null],[28,[37,11],[\"toggleMobileView\"],null],[28,[37,11],[\"logout\"],null],[30,0,[\"sidebarEnabled\"]],[30,0,[\"showSidebar\"]],[30,0,[\"toggleSidebar\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,12],null,[[\"@canSignUp\",\"@showCreateAccount\",\"@showLogin\",\"@showKeyboard\",\"@toggleMobileView\",\"@logout\",\"@sidebarEnabled\",\"@navigationMenuQueryParamOverride\",\"@showSidebar\",\"@toggleSidebar\"],[[30,0,[\"canSignUp\"]],[28,[37,11],[\"showCreateAccount\"],null],[28,[37,11],[\"showLogin\"],null],[28,[37,11],[\"showKeyboardShortcutsHelp\"],null],[28,[37,11],[\"toggleMobileView\"],null],[28,[37,11],[\"logout\"],null],[30,0,[\"sidebarEnabled\"]],[30,0,[\"navigationMenuQueryParamOverride\"]],[30,0,[\"showSidebar\"]],[28,[37,13],[[30,0],\"toggleSidebar\"],null]]],null],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n  \"],[8,[39,14],null,null,null],[1,\"\\n\\n\"],[41,[30,0,[\"siteSettings\",\"enable_offline_indicator\"]],[[[1,\"    \"],[8,[39,15],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[8,[39,7],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"below-site-header\",\"div\",[28,[37,8],null,[[\"currentPath\"],[[30,0,[\"router\",\"_router\",\"currentPath\"]]]]]]],null],[1,\"\\n\\n  \"],[10,0],[14,1,\"main-outlet-wrapper\"],[14,0,\"wrap\"],[14,\"role\",\"main\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"sidebar-wrapper\"],[12],[1,\"\\n\"],[41,[28,[37,16],[[30,0,[\"sidebarEnabled\"]],[30,0,[\"showSidebar\"]]],null],[[[1,\"        \"],[8,[39,17],null,[[\"@toggleSidebar\"],[[28,[37,13],[[30,0],\"toggleSidebar\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n    \"],[8,[39,18],null,null,null],[1,\"\\n\\n    \"],[8,[39,7],null,[[\"@name\"],[\"before-main-outlet\"]],null],[1,\"\\n\\n    \"],[10,0],[14,1,\"main-outlet\"],[12],[1,\"\\n      \"],[8,[39,7],null,[[\"@name\",\"@connectorTagName\"],[\"above-main-container\",\"div\"]],null],[1,\"\\n      \"],[10,0],[14,0,\"container\"],[14,1,\"main-container\"],[12],[1,\"\\n\"],[41,[30,0,[\"showTop\"]],[[[1,\"          \"],[8,[39,19],null,[[\"@name\"],[\"top\"]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[8,[39,20],null,null,null],[1,\"\\n        \"],[8,[39,21],null,null,null],[1,\"\\n        \"],[8,[39,22],null,null,null],[1,\"\\n        \"],[8,[39,7],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"top-notices\",\"div\",[28,[37,8],null,[[\"currentPath\"],[[30,0,[\"router\",\"_router\",\"currentPath\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[46,[28,[37,24],null,null],null,null,null],[1,\"\\n\\n      \"],[8,[39,25],null,null,null],[1,\"\\n      \"],[8,[39,7],null,[[\"@name\",\"@outletArgs\"],[\"main-outlet-bottom\",[28,[37,8],null,[[\"showFooter\"],[[30,0,[\"showFooter\"]]]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,7],null,[[\"@name\"],[\"after-main-outlet\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showPoweredBy\"]],[[[1,\"      \"],[8,[39,26],null,null,null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[8,[39,7],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"above-footer\",\"div\",[28,[37,8],null,[[\"showFooter\"],[[30,0,[\"showFooter\"]]]]]]],null],[1,\"\\n\"],[41,[30,0,[\"showFooter\"]],[[[1,\"    \"],[8,[39,19],null,[[\"@name\",\"@triggerAppEvent\",\"@classNames\"],[\"footer\",\"true\",\"custom-footer-content\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[8,[39,7],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"below-footer\",\"div\",[28,[37,8],null,[[\"showFooter\"],[[30,0,[\"showFooter\"]]]]]]],null],[1,\"\\n\\n  \"],[8,[39,27],null,null,null],[1,\"\\n  \"],[8,[39,28],null,null,null],[1,\"\\n  \"],[8,[39,29],null,null,null],[1,\"\\n  \"],[8,[39,30],null,null,null],[1,\"\\n  \"],[8,[39,31],null,null,null],[1,\"\\n  \"],[8,[39,32],null,null,null],[1,\"\\n\\n\"],[41,[30,0,[\"showFooterNav\"]],[[[1,\"    \"],[8,[39,33],null,null,null],[1,\"\\n\"]],[]],null]],[]]]]],[1,\"\\n\\n\"],[8,[39,34],null,null,null],[1,\"\\n\"],[8,[39,35],null,null,null],[1,\"\\n\"],[8,[39,36],null,null,null]],[],false,[\"d-styles\",\"d-virtual-height\",\"discourse-root\",\"did-insert\",\"i18n\",\"d-document\",\"page-loading-slider\",\"plugin-outlet\",\"hash\",\"if\",\"glimmer-site-header\",\"route-action\",\"site-header\",\"action\",\"software-update-prompt\",\"offline-indicator\",\"and\",\"sidebar\",\"loading-slider-fallback-spinner\",\"custom-html\",\"notification-consent-banner\",\"pwa-install-banner\",\"global-notice\",\"component\",\"-outlet\",\"card-container\",\"powered-by-discourse\",\"d-lightbox\",\"modal-container\",\"dialog-holder\",\"topic-entrance\",\"composer-container\",\"render-glimmer-container\",\"footer-nav\",\"d-menus\",\"d-tooltips\",\"d-toasts\"]]",
  "moduleName": "discourse/templates/application.hbs",
  "isStrictMode": false
});